<app-json-view [data]="data" [forPrint]="true"></app-json-view>